import React from 'react'
import { useForm } from "react-hook-form";
import { TextField, Button, Stack, MenuItem } from "@mui/material";

const CountriesForm = () => {
    const { register, handleSubmit, watch, formState: { errors }, handleChange, control } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    }

    return (
        <>
            <div>
                

                <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off' >
                    <Stack spacing={2}>
                    <h1>Countries Form</h1>

                    <TextField name="country_id" label='Country id' {...register("country_id")} />
                    <TextField name="country_name" label='Country name' {...register("country_name")} />
                    <Button type='submit' variant="outlined">Submit</Button>

                    </Stack>

                </form>


            </div>




        </>
    )
}

export default CountriesForm